var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{style:({ borderRadius: '20px', width: _vm.width }),attrs:{"color":_vm.color,"height":_vm.height,"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }